import { Box } from "@mui/material";

const SwitchButtons = ({activeContent, setActiveContent, texts}) => {
    
    return (
        <Box
            sx={{
                background: 'linear-gradient(to right, var(--themeCyan), var(--themeMagenta), var(--themeYellow))',
                // background: 'grey',
                display: 'flex',
                flexDirection: 'row',
                width: '100%'
            }}
        >
            {texts.map((i,j) => (
                <SwitchButton 
                    key={j}
                    isDisabled={i.content === activeContent} 
                    setActiveContent={setActiveContent} 
                    text={i.text}
                    content={i.content}
                    isRight={j === (texts.length - 1)} 
                />
            ))}
        </Box>
    );
};

const SwitchButton = ({isDisabled, content, setActiveContent, text, isRight}) => (
    <Box
        sx={{
            
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '15px'
        }}
    >
        <button
            className={`switchButton ${isRight && 'switchButton-right'}`} 
            disabled={isDisabled} 
            onClick={()=>setActiveContent(() => content)}
        >
            {text}
        </button>
    </Box>
);

export default SwitchButtons;